import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { dot } from './styles.js';

var Dot = /*#__PURE__*/React__default.memo(function (_ref) {
  var count = _ref.count,
    isActive = _ref.isActive,
    isCurrent = _ref.isCurrent,
    id = _ref.id,
    size = _ref.size,
    activeSize = _ref.activeSize,
    activeColor = _ref.activeColor,
    inactiveColor = _ref.inactiveColor,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    vertical = _ref.vertical,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === undefined ? function (index, count) {
      return "Step ".concat(index + 1, " of ").concat(count);
    } : _ref$ariaLabel;
  var onClick = React__default.useCallback(function () {
    return onChange && !disabled && onChange(id);
  }, [id, disabled, onChange]);
  var onKeyDown = React__default.useCallback(function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  }, [onClick]);
  var accessibilityProps = React__default.useMemo(function () {
    return !onChange ? {
      'aria-hidden': true
    } : {
      onClick: onClick,
      onKeyDown: onKeyDown,
      tabIndex: 0,
      role: 'button',
      'aria-label': ariaLabel(id, count),
      'aria-disabled': disabled ? true : undefined,
      'aria-current': isCurrent ? 'step' : undefined
    };
  }, [onChange, disabled, isCurrent, id, count, ariaLabel, onClick, onKeyDown]);
  return /*#__PURE__*/React__default.createElement(dot, _extends({
    "data-testid": "elemental-ui-Dot-".concat(id),
    $vertical: vertical,
    $size: size,
    $activeSize: activeSize,
    $activeColor: activeColor,
    $inactiveColor: inactiveColor,
    $controlled: !!onChange,
    $disabled: disabled,
    $active: isActive,
    $current: isCurrent
  }, accessibilityProps));
});
Dot.displayName = 'Dot';

export { Dot };
